import { getAspectRatioStyle } from "@common/controls/AspectRatioContainer/lib";
import classnames from "classnames";
import * as React from "react";
import { type VideoProps } from "../component";
import { getAllow } from "../lib";
import { getSrc } from "./lib";

export type VzaarVideoProps = VideoProps & {
  videoId?: string;
};

const VzaarVideo = (props: VzaarVideoProps) => (
  <div
    className={classnames("video_container", { background: props.isBackground })}
    style={getAspectRatioStyle(props.aspectRatio)}
  >
    <div className="video vzaar_video">
      <iframe allow={getAllow(props)} height="100%" width="100%" src={getSrc(props)} />

      {props.isBackground && <div className="overlay" />}
    </div>
  </div>
);

export default VzaarVideo;
